import React, { useMemo, useState, useEffect } from 'react';
import { Modal, Input, List } from 'antd';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import './esim-location-dialog.scss';
import { get } from '../../../utils/request';

const EsimLocationDialog = ({ open, onClose, countries = [] , className=""}) => {
  const [contryFlagsMap, setCountryFlagsMap] = useState(null);
  const [keyword, setKeyword] = useState('');

  const filteredCountries = useMemo(() => {
    if (!keyword.trim()) return countries;
    const k = keyword.toLowerCase();
    return countries.filter(
      (c) =>
        c.locationName?.toLowerCase().includes(k)
    );
  }, [countries, keyword]);

  const handleSearchChange = (e) => {
    setKeyword(e.target.value);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (open && !contryFlagsMap) {
      fetchCountryFlags();
    }
  }, [open]);

  const fetchCountryFlags = async () => {
    try {
      const result = await get('/appConfig/countryFlags');
      setCountryFlagsMap(result);
    } catch (e) {
      
    }
  };

  const countryCodeToEmoji = (iso2) => {
    if (!iso2 || iso2.length !== 2) return '🏳️';
    const codePoints = [...iso2.toUpperCase()].map(
      (c) => 127397 + c.charCodeAt(0),
    );
    return String.fromCodePoint(...codePoints);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={null}
      className={`country-network-dialog ${className}`}
      width="35%"
      centered
      destroyOnClose
      maskClosable
    >
      <div className="cnd-header">
        <h2 className="cnd-title">Coverage<span className="cnd-subtitle">{countries.length} Locations</span></h2>
        <button className="cnd-close" onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>

      <div className="cnd-search">
        <Input
          allowClear
          size="large"
          placeholder="Search"
          prefix={<SearchOutlined />}
          value={keyword}
          onChange={handleSearchChange}
        />
      </div>

      <div className="cnd-list-wrapper">
        <List
          dataSource={filteredCountries}
          className="cnd-list"
          renderItem={(item) => (
            <List.Item className="cnd-item">
              <div className="cnd-item__left">
                <div className="cnd-flag">
                  {!!contryFlagsMap && contryFlagsMap[item.locationCode] ? (
                    <img
                      src={contryFlagsMap[item.locationCode].square_image_url}
                      alt={item.locationCode}
                    />
                  ) : (
                    <span className="cnd-flag__emoji">
                      {countryCodeToEmoji(item.locationCode)}
                    </span>
                  )}
                </div>
                <div className="cnd-country-name">{item.locationName.replace(/\s*\(.*?\)\s*$/, '')}</div>
              </div>

              <div className="cnd-item__right">
                {(item.operatorList || []).map((operator) => (
                  <div className="cnd-network-row" key={operator.operatorName}>
                    <span className="cnd-network-name">{operator.operatorName}</span>
                    {operator.networkType && (
                      <span className="cnd-network-badge">{operator.networkType}</span>
                    )}
                  </div>
                ))}
              </div>
            </List.Item>
          )}
        />
      </div>
    </Modal>
  );
};

export default EsimLocationDialog;